// export default function checkRequiredInputs(requiredInputs, submitBtn) {
//     let allInputsFilled = true;

//     requiredInputs.forEach(input => {
//       if (input.type === 'checkbox') {
//         if (!input.checked) {
//           allInputsFilled = false;
//         }
//       } else {
//         if (!input.value.trim()) {
//           allInputsFilled = false;
//         }
//       }
//     });

//     if (allInputsFilled) {
//       submitBtn.disabled = false;
//     } else {
//       submitBtn.disabled = true;
//     };
//   };

export default function checkRequiredInputs(requiredInputs, submitBtn) {
  let allInputsFilled = true;
  const radioGroups = {};

  requiredInputs.forEach((input) => {
    if (input.type === "checkbox") {
      if (!input.checked) {
        allInputsFilled = false;
      }
    } else if (input.type === "radio") {
      if (!radioGroups[input.name]) {
        radioGroups[input.name] = false;
      }
      if (input.checked) {
        radioGroups[input.name] = true;
      }
    } else {
      if (input.value === undefined || input.value.trim() === "") {
        allInputsFilled = false;
      }
    }
  });

  // Check that all radio groups have at least one selected option
  for (const groupName in radioGroups) {
    if (radioGroups.hasOwnProperty(groupName)) {
      if (!radioGroups[groupName]) {
        allInputsFilled = false;
      }
    }
  }

  if (submitBtn) {
    submitBtn.disabled = !allInputsFilled;
  }
}
